// extracted by mini-css-extract-plugin
export var childPages = "Article-module--childPages--AyoiI";
export var footer = "Article-module--footer--Kq+Hc";
export var siblingPages = "Article-module--siblingPages--Ygeqr";